import { Injectable } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-browser';

// Holds the result of the very first handleRedirectPromise() call made during
// APP_INITIALIZER, so the LoginComponent can pick it up once it mounts.
// Needed because msalSubject$ is a plain Subject — emitting LOGIN_SUCCESS
// before any component subscribes loses the event.
@Injectable({ providedIn: 'root' })
export class MsalRedirectService {
  private result: AuthenticationResult | null = null;

  set(result: AuthenticationResult | null): void {
    this.result = result;
  }

  consume(): AuthenticationResult | null {
    const r = this.result;
    this.result = null;
    return r;
  }
}
